'use client';

import React, { useState } from 'react';
import { Slide } from '@/shared/types';
import { ArchiveIcon, CaretDownIcon } from '@phosphor-icons/react';
import SimplifiedSources from '../cells/simplifiedSources';
import { motion } from 'framer-motion';
// Interfaces and types
interface SourcesPaneProps {
  slide: Slide;
  onToggle?: (isExpanded: boolean) => void;
}

// Component definition
const SourcesPane: React.FC<SourcesPaneProps> = ({
  slide,
  onToggle
}) => {
  // Initialize state
  const [showSources, setShowSources] = useState(false);
  return <div className={`flex flex-col gap-2 slide-boxes hover:text-white text-white/65 transition-colors duration-300 w-full p-1 ${showSources ? 'pb-3' : ''} px-[10px]`} data-sentry-component="SourcesPane" data-sentry-source-file="sourcesPane.tsx">
      <button className='flex flex-row items-center gap-2 btn-h w-full active:bg-transparent justify-between hover:bg-transparent' onClick={() => {
      const newState = !showSources;
      setShowSources(newState);
      onToggle?.(newState);
    }}>
        <div className='flex flex-row items-center gap-2 text-lg'>
          <ArchiveIcon weight="duotone" className='w-6 h-6' data-sentry-element="ArchiveIcon" data-sentry-source-file="sourcesPane.tsx" />
          Sources
        </div>
        <CaretDownIcon weight="bold" className={`w-5 h-5 mr-4 transform transition-transform duration-300 ${showSources ? '-rotate-180' : ''}`} data-sentry-element="CaretDownIcon" data-sentry-source-file="sourcesPane.tsx" />
      </button>
        {showSources && <motion.div data-testid='sources-container-pane' className='flex flex-col gap-2 overflow-y-none custom-scrollbar2 pl-2 pr-0 max-h-[250px]' initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3,
      ease: "easeInOut"
    }}>
            <SimplifiedSources value={slide.sources || []} slide={Number(slide.id)} isInPresentationView={true} editingEnabled={false} />
          </motion.div>}
    </div>;
};
export default SourcesPane;